import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MeterDto,
  MeteringPointAssociateVerificationMeterDto,
  MeteringPointDto,
  MeteringPointService,
  MeterService,
  Quadrant
} from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-create-control-meter-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    SelectDirective,
    TranslatePipe
  ],
  templateUrl: './create-control-meter-modal.component.html',
  styleUrl: './create-control-meter-modal.component.css'
})
export class CreateControlMeterModalComponent implements OnInit, HasUnsavedChanges{
  /** Form **/
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl('', Validators.required),
    serialNumber: new FormControl({ value: null, disabled: true }, Validators.required),
    quadrant: new FormControl(null, Validators.required),
    validFrom: new FormControl('', [Validators.required]),
    meterNumber: new FormControl(null, Validators.required),
    relativeDeviation: new FormControl(null, Validators.required),
    absoluteDeviation: new FormControl(null, Validators.required),
  });

  /** Meter List **/
  public meterList: MeterDto[] = [];

  /** Quadrant **/
  public quadrant: KeyValue[] = enumToKeyValue(Quadrant, { omitKeys: ['NotSpecified'], prefixValue: 'enum.quadrant.' });

  /** Meteringpoint **/
  public meteringPoint?: MeteringPointDto;

  constructor(
    private readonly meteringPointService: MeteringPointService,
    private readonly formApiService: FormApiService,
    private readonly meterService: MeterService,
  ) {
  }

  public ngOnInit(): void {
    if (this.meteringPoint?.identification) {
      /** Get Meter List **/
      this.meterService.meterGetbymeteringpointGet(this.meteringPoint?.identification).subscribe({
        next: (data: MeterDto[]) => {
          this.meterList = data;
        },
        error: () => {
          this.meterList = [];
        }
      });

      /** Subscribe to Meter Number **/
      this.form.get('meterNumber')?.valueChanges.subscribe((data: string) => {
        const element = this.meterList.find((meter: MeterDto) => meter.id === data);
        this.form.get('serialNumber')?.setValue(element?.serialNumber);
      });
    }
  }

  public submit(): void {
    /** Set ID **/
    this.form.get('meteringPointIdentification')?.setValue(this.meteringPoint?.identification);

    /** Form ApiService **/
    this.formApiService.submit<MeteringPointAssociateVerificationMeterDto>(
      this.form,
      (data) => this.meteringPointService.meteringPointAssociateVerificationMeterPost(data),
      {
        preprocess: (data) => ({
          ...data,
          serialNumber: this.form.get('serialNumber')?.value,
        }),
        successMessage: 'meteringpoint.meter.createcontrolmeter.success',
        closeModal: true
      },
    );
  }

}
